define('lib/Podio.UI.Dropdowns',['require','jquery','lib/Podio.Event.UI','lib/Podio.UI.Tooltips'],function(require) {

  var $ = require('jquery');
  var eventUI = require('lib/Podio.Event.UI');
  var tooltips = require('lib/Podio.UI.Tooltips');

  function hide(elmTarget) {
    elmTarget.removeClass('open');
    elmTarget.unbind('outsideclick.podiodropdowns');
  }

  function onOutsideClick(e) {
    hide($(e.currentTarget));
  }

  function onDropdownToggleButtonClicked(elmTarget, e) {
    e.stopPropagation();

    var elmParent = elmTarget.parent();
    tooltips.hideAll();

    if(elmParent.hasClass('open')) {
      hide(elmParent);
      return;
    }

    elmParent.addClass('open');
    elmParent.bind("outsideclick.podiodropdowns", onOutsideClick);
  }

  eventUI.bind('click', '.button-dropdown-toggle', onDropdownToggleButtonClicked);

});

